import { render, staticRenderFns } from "./RegistrationDetailsEditCloudAccount.vue?vue&type=template&id=5d3a9470"
import script from "./RegistrationDetailsEditCloudAccount.vue.ts?vue&type=script&lang=ts&external"
export * from "./RegistrationDetailsEditCloudAccount.vue.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports